import React, { useEffect, useState } from "react";
import { FileDownloadOutlined } from "@mui/icons-material";
import axios from "axios";
import baseURL from "../../../../../configs/api";
import AllRoles from "./AllRoles";
import PleaseWaitPopup from "../../../../PleaseWaitPopup";
import Cookies from "js-cookie";
import { put_AccessControlByGroupName } from "../../../../../services/acessControl";
import { useTheme } from "../../../../../components/hooks/useTheme";
import { Tabs } from "../../../../../components/common/Tabs";
import useTenant from "../../../../../components/hooks/useTenant";

export default function AccessControl() {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { handleTenantError }: any = useTenant();
  const token = Cookies.get("token-jj-rental-ui");
  const [pages, setPages] = React.useState<any[]>([]);
  const [currentPage, setCurrentPage] = React.useState<any | null>(null);
  const [searchValue, setSearchValue] = useState<string>("");
  const [expandListGroup, setExpandListGroup] = useState<any[]>([]);
  const [pleaseWait, setPleaseWait] = useState<boolean>(false);
  const [isChange, setIsChange] = useState<number>(0);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleOnClick = (tab: any, index: number) => {
    setCurrentPage({
      id: tab?.id,
      name: tab?.label,
    });
    setActiveTabIndex(index);
  };

  useEffect(() => {
    setPleaseWait(true);
    axios
      .get(`${baseURL}roles`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setPages(() =>
          response?.data
            ?.filter((value: any) => value?.roleName?.toLowerCase()?.trim() !== "admin")
            ?.map((item: any) => {
              return {
                id: item.id,
                label: item.roleName,
              };
            })
        );

        const currentRole = response?.data?.find((value: any) => value?.roleName?.toLowerCase()?.trim() !== "admin");

        if (currentRole) {
          setCurrentPage({
            id: currentRole?.id || 0,
            name: currentRole?.roleName || "N/A",
          });
        }

        setPleaseWait(false);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWait(false);
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getExpandGroupsDetails = (expandList: any[]) => {
    setExpandListGroup(() => expandList);
  };

  const updateToNotSetAll = () => {
    if (expandListGroup.length !== 0) {
      setPleaseWait(true);
      let count = 0;
      expandListGroup.forEach(async (item: any) => {
        put_AccessControlByGroupName(item.sections[0].roleId, item.groupName, 1, token!.toString(), tenantId)
          .then(() => {
            count++;
            if (expandListGroup.length === count) {
              setIsChange(1);
            }
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWait(false);
            handleTenantError(error);
          });
      });
    }
  };

  const updateToAllowAll = () => {
    if (expandListGroup.length !== 0) {
      setPleaseWait(true);
      let count = 0;
      expandListGroup.forEach(async (item: any) => {
        put_AccessControlByGroupName(item.sections[0].roleId, item.groupName, 2, token!.toString(), tenantId)
          .then(() => {
            count++;
            if (expandListGroup.length === count) {
              setIsChange(2);
            }
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWait(false);
            handleTenantError(error);
          });
      });
    }
  };

  const updateToDenyAll = () => {
    if (expandListGroup.length !== 0) {
      setPleaseWait(true);
      let count = 0;
      expandListGroup.forEach(async (item: any) => {
        put_AccessControlByGroupName(item.sections[0].roleId, item.groupName, 3, token!.toString(), tenantId)
          .then(() => {
            count++;
            if (expandListGroup.length === count) {
              setIsChange(3);
            }
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWait(false);
            handleTenantError(error);
          });
      });
    }
  };

  return (
    <div>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full flex justify-between items-center mt-2">
            <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>
              Access Control
            </h2>

            <div className="flex items-center gap-2">
              <input
                type="text"
                placeholder="Search..."
                className="h-[30px] px-2 border border-gray-300 rounded text-sm"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />

              <button
                className="h-[30px] px-3 bg-white text-gray-600 border border-gray-400 rounded text-xs font-bold capitalize hover:bg-gray-100"
                onClick={() => updateToNotSetAll()}
              >
                Not Set All
              </button>

              <button
                className="h-[30px] px-3 bg-green-500 text-white rounded text-xs font-bold capitalize hover:bg-green-600"
                onClick={() => updateToAllowAll()}
              >
                Allow All
              </button>

              <button
                className="h-[30px] px-3 bg-red-600 text-white rounded text-xs font-bold capitalize hover:bg-red-700"
                onClick={() => updateToDenyAll()}
              >
                Deny All
              </button>

              <div
                className="h-[30px] px-2 flex items-center bg-white text-black border-2 border-gray-300 rounded cursor-pointer hover:bg-gray-100"
              >
                <FileDownloadOutlined />
              </div>
            </div>
          </div>

          <div>
            <Tabs
              tabs={pages}
              activeIndex={activeTabIndex}
              onChange={(index, tab) => handleOnClick(tab, index)}
            />

            <div>
              {
                currentPage && (
                  <AllRoles
                    roleId={currentPage.id}
                    searchValue={searchValue}
                    getExpandGroupsDetails={(expandList) => getExpandGroupsDetails(expandList)}
                    setPleaseWait={(wait) => setPleaseWait(wait)}
                    isChange={isChange}
                    updateToZeroChange={() => setIsChange(0)}
                  />
                )
              }
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWait} />
    </div>
  );
}
